import type { StateCreator } from 'zustand'

interface FeedbackDialogBase {
  feedbackDialogOpen: boolean
}

interface FeedbackDialogActions {
  setFeedbackDialogOpen: (
    nextOpen:
      | FeedbackDialogBase['feedbackDialogOpen']
      | ((
          currentOpen: FeedbackDialogBase['feedbackDialogOpen']
        ) => FeedbackDialogBase['feedbackDialogOpen'])
  ) => void
}

export interface FeedbackDialogState
  extends FeedbackDialogBase, FeedbackDialogActions {}

export const createFeedbackDialogStore: StateCreator<FeedbackDialogState> = (
  set
) => ({
  feedbackDialogOpen: false,
  setFeedbackDialogOpen: (nextOpen) => {
    set((state) => ({
      feedbackDialogOpen:
        typeof nextOpen === 'function'
          ? nextOpen(state.feedbackDialogOpen)
          : nextOpen,
    }))
  },
})
